export const formatString = (value: string) =>
  value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

export function TopicFormatter({ value }: { value: string }) {
  return <>{formatString(value)}</>;
}
